<template>

    <div class="approve-registration-to-careers">

      <div class="page-content-wrapper choose-career-screen mb-3">
        <div class="container choose-career-screen">
          <div class="card">
            <div class="card-block">
              <h4 class="mt-0 header-title">Inscripción a carreras</h4>
              <div class="row mb-3">
                <div class="col-md-6">
                  <label>Carrera</label>
                  <div class="form-group" style="margin: auto;" v-bind:class="{ 'has-danger': $v.career.$error }">
                    <select id="career" @change="onCareerHasChanged()"  class="custom-select form-control" v-model="career">
                      <option v-for="career in careers" v-bind:value="career._id">
                        {{ career.name }}
                      </option>
                    </select>
                    <div class="form-control-feedback" v-if="!$v.career.required && $v.career.$error">Seleccione una carrera.</div>
                  </div>
                </div>
                <div class="col-md-4">
                  <label>Nivel</label>
                  <div class="form-group" style="margin: auto;" v-bind:class="{ 'has-danger': $v.level.$error }">
                    <select id="level" class="custom-select form-control" v-model="level">
                      <option v-for="level in levels" v-bind:value="level.value">
                        {{ level.text }}
                      </option>
                    </select>
                    <div class="form-control-feedback" v-if="!$v.level.required && $v.level.$error">Seleccione el nivel.</div>
                  </div>
                </div>

                <div class="col-md-6 mt-3">
                  <label>Plan de estudio</label>
                  <div class="form-group" style="margin: auto;" v-bind:class="{ 'has-danger': $v.studyPlan.$error }">
                    <select v-if="career" id="studyPlan" class="custom-select form-control" v-model="studyPlan">
                      <option v-for="studyPlanItem in studyPlans" v-bind:value="studyPlanItem._id">
                        Res. {{ studyPlanItem.resolution }} ({{ studyPlanItem.fileNumber }})
                      </option>
                    </select>
                    <div class="form-control-feedback" v-if="!$v.studyPlan.required && $v.studyPlan.$error">Seleccione un plan de estudio.</div>
                  </div>
                </div>

                <div class="form-group col-md-4 mt-5">
                  <label class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" v-model="repeatingTheClass">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">Recursante</span>
                  </label>
                </div>
              </div>








              <h4 class="mt-5 header-title">Datos personales</h4>
              <div class="card-text">
                <div class="row">
                  <div class="form-group col-sm-12 col-md-6 col-lg6 col-xl-6" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.lastName.$error }">
                    <label>Apellido</label>
                    <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Perez" v-model="registrationForm.personalData.lastName">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.lastName.required && $v.registrationForm.personalData.lastName.$error">El apellido es requerido.</div>
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.lastName.minLength && $v.registrationForm.personalData.lastName.$error">El apellido debe tener al menos 3 caracteres.</div>
                  </div>
                  <div class="form-group col-sm-12 col-md-6 col-lg6 col-xl-6" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.firstName.$error }">
                    <label>Nombre</label>
                    <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Juan" v-model="registrationForm.personalData.firstName">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.firstName.required && $v.registrationForm.personalData.firstName.$error">El nombre es requerido.</div>
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.firstName.minLength && $v.registrationForm.personalData.firstName.$error">El nombre debe tener al menos 3 caracteres.</div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.dni.$error }">
                    <label>Dni</label>
                    <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="36194445" v-model="registrationForm.personalData.dni">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.dni.required && $v.registrationForm.personalData.dni.$error">El dni es requerido.</div>
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.dni.minLength && $v.registrationForm.personalData.dni.$error">El dni debe tener al menos 8 numeros.</div>
                  </div>

                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.cuil.$error }">
                    <label>Cuil</label>
                    <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="20361944454" v-model="registrationForm.personalData.cuil">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.cuil.minLength && $v.registrationForm.personalData.cuil.$error">El cuil debe tener al menos 11 numeros.</div>
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.cuil.required && $v.registrationForm.personalData.cuil.$error">El cuil es requerido.</div>
                  </div>

                  <div class="form-group col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.birthDate.$error }">
                    <label>Fecha de nacimiento</label>
                    <masked-input mask="1111-11-11" type="text" class="form-control" v-model="registrationForm.personalData.birthDate" @input="$v.registrationForm.personalData.birthDate.$touch()" />
                    <small>(Ingresar la fecha con el formato: YYYY-MM-DD)</small>
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.birthDate.required && $v.registrationForm.personalData.birthDate.$error">La fecha de nacimiento es requerida.</div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.gender.$error }">
                    <label>Sexo</label>
                    <div>
                      <label v-for="gender in genders" class="custom-control custom-checkbox mb-2 mr-sm-2 mb-sm-0">
                        <input name="gender" type="radio" class="form-check-input mb-2 mr-sm-2 mb-sm-0" v-bind:value="gender.value" v-model="registrationForm.personalData.gender">
                        {{ gender.text }}
                      </label>
                    </div>
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.gender.required && $v.registrationForm.personalData.gender.$error">El sexo es requerido.</div>
                  </div>

                  <div class="form-group col-sm-12 col-md-2" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.size.$error }">
                    <label>Talla</label>
                    <select v-model="registrationForm.personalData.size" class="form-control mb-2 mr-sm-2 mb-sm-0">
                      <option v-for="size in sizes" :value="size.value">{{ size.text }}</option>
                    </select>
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.size.required && $v.registrationForm.personalData.size.$error">La talla es requerida.</div>
                  </div>

                  <div class="form-group col-sm-12 col-md-6" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.email.$error }">
                    <label>Correo electrónico</label>
                    <input type="mail" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="ejemplo@example.com" v-model="registrationForm.personalData.email">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.email.required && $v.registrationForm.personalData.email.$error">El email es requerido.</div>
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.email.email && $v.registrationForm.personalData.email.$error">Ingrese un email válido.</div>
                  </div>
                </div>
              </div>

              <!--lugar de nacimiento-->
              <h4 class="mt-5 header-title">Lugar de nacimiento</h4>
              <div class="card-text">
                <div class="row">
                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.birthPlace.nationality.$error }">
                    <label>Nacionalidad</label>
                    <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Argentina" v-model="registrationForm.personalData.birthPlace.nationality">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.birthPlace.nationality.required && $v.registrationForm.personalData.birthPlace.nationality.$error">La nacionalidad es requerida.</div>
                  </div>
                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.birthPlace.province.$error }">
                    <label>Provincia</label>
                    <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Corrientes" v-model="registrationForm.personalData.birthPlace.province">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.birthPlace.province.required && $v.registrationForm.personalData.birthPlace.province.$error">La provincia de nacimiento es requerida.</div>
                  </div>
                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.birthPlace.locality.$error }">
                    <label>Localidad</label>
                    <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Corrientes" v-model="registrationForm.personalData.birthPlace.locality">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.birthPlace.locality.required && $v.registrationForm.personalData.birthPlace.locality.$error">La localidad de nacimiento es requerida.</div>
                  </div>
                </div>
              </div>

              <!--lugar de residencia actual-->
              <h4 class="mt-5 header-title">Lugar de residencia actual</h4>
              <div class="card-text">
                <div class="row">
                  <div class="form-group col-sm-12 col-md-6" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.street.$error }">
                    <label>Domicilio / Calle</label>
                    <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Rioja" v-model="registrationForm.personalData.currentResidence.street">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.street.required && $v.registrationForm.personalData.currentResidence.street.$error">La calle es requerida.</div>
                  </div>
                  <div class="form-group col-sm-12 col-md-2" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.streetNumber.$error }">
                    <label>N°</label>
                    <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="663" v-model="registrationForm.personalData.currentResidence.streetNumber">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.streetNumber.required && $v.registrationForm.personalData.currentResidence.streetNumber.$error">El número de la calle es requerido.</div>
                  </div>
                  <div class="form-group col-sm-12 col-md-2">
                    <label>Piso</label>
                    <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0"  placeholder="1" v-model="registrationForm.personalData.currentResidence.floor">
                  </div>
                  <div class="form-group col-sm-12 col-md-2">
                    <label>Depto</label>
                    <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0"  placeholder="1A" v-model="registrationForm.personalData.currentResidence.departamentNumber">
                  </div>
                </div>


                <div class="row">
                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.country.$error }">
                    <label>País</label>
                    <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Argentina" v-model="registrationForm.personalData.currentResidence.country">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.country.required && $v.registrationForm.personalData.currentResidence.country.$error">El país es requerido.</div>
                  </div>
                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.province.$error }">
                    <label>Provincia</label>
                    <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Corrientes" v-model="registrationForm.personalData.currentResidence.province">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.province.required && $v.registrationForm.personalData.currentResidence.province.$error">La provincia actual es requerida.</div>
                  </div>
                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.locality.$error }">
                    <label>Localidad</label>
                    <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Corrientes" v-model="registrationForm.personalData.currentResidence.locality">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.locality.required && $v.registrationForm.personalData.currentResidence.locality.$error">La localidad actual es requerida.</div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.neighborhood.$error }">
                    <label>Barrio</label>
                    <input type="text" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="Libertad" v-model="registrationForm.personalData.currentResidence.neighborhood">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.neighborhood.required && $v.registrationForm.personalData.currentResidence.neighborhood.$error">El barrio es requerido.</div>
                  </div>

                  <div class="form-group col-sm-12 col-md-3" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.zipCode.$error }">
                    <label>Código Postal</label>
                    <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0"  placeholder="3400" v-model="registrationForm.personalData.currentResidence.zipCode">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.zipCode.required && $v.registrationForm.personalData.currentResidence.zipCode.$error">El código postal es requerido.</div>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.phone.$error }">
                    <label>Teléfono fijo</label>
                    <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="3794123456" v-model="registrationForm.personalData.currentResidence.phone">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.phone.required &&  $v.registrationForm.personalData.currentResidence.phone.$error">El teléfono es requerido.</div>
                  </div>

                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.cellPhone.$error }">
                    <label>Celular</label>
                    <input type="number" class="form-control mb-2 mr-sm-2 mb-sm-0" placeholder="3794123456" v-model="registrationForm.personalData.currentResidence.cellPhone">
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.cellPhone.required && $v.registrationForm.personalData.currentResidence.cellPhone.$error">El celular es requerido.</div>
                  </div>

                  <div class="form-group col-sm-12 col-md-4" v-bind:class="{ 'has-danger': $v.registrationForm.personalData.currentResidence.cellPhoneCompany.$error }">
                    <label>Compañia</label>
                    <select v-model="registrationForm.personalData.currentResidence.cellPhoneCompany" class="form-control mb-2 mr-sm-2 mb-sm-0">
                      <option v-for="Company in cellPhoneCompanies" :value="Company.value">{{ Company.text }}</option>
                    </select>
                    <div class="form-control-feedback" v-if="!$v.registrationForm.personalData.currentResidence.cellPhoneCompany.required && $v.registrationForm.personalData.currentResidence.cellPhoneCompany.$error">La compañia celular es requerida.</div>
                  </div>
                </div>

              </div>


              <h4 class="mt-5 header-title">Estado de la inscripción</h4>

              <div class="row mb-3"><!-- Asi nos aseguramos de que el tesorero pueda cambiar todos los estados -->
                <div class="col-md-6">
                  <select id="stateOfRegistrationToCareer" class="custom-select form-control" v-model="studentRegistrationStatus">
                    <option :value="null">Estado</option>
                    <option v-for="state in statesOfRegistrationToCareer" v-bind:value="state.value" v-bind:disabled="!state.permit">
                      {{ state.text }}
                    </option>
                  </select>
                </div>
              </div>



              <div class="row mb-3">
                <div class="col-md-6">
                  <label>Observaciones</label>
                  <div class="form-group" style="margin: auto;">
                    <textarea class="form-control" v-model="observations"></textarea>
                  </div>
                </div>
              </div>

              <div class="row mb-3 pull-right">
                <div class="col-md-12">
                  <div class="loading waves-effect mr-2" v-if="isSaving">
                    <i class="fa fa-spin fa-circle-o-notch"></i>
                  </div>
                  <button class="btn btn-secondary" @click="cancel()">Cancelar</button>
                  <button class="btn btn-primary save-btn" @click="submit()">Guardar</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

</template>
<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import levels from '../data/levels'
import sizes from '../data/sizes'
import genders from '../data/genders'
import cellPhoneCompanies from '../data/cellPhoneCompanies'
import statesOfRegistrationToCareer from '../data/statesOfRegistrationToCareer'
import MaskedInput from 'vue-masked-input'


export default {

  name: 'approve-registration-to-careers',


  components: {
    MaskedInput,
  },


  created(){
    this.getAllCareers();
    this.getRegistrationToCareer();
    this.verifyPermission();
  },


  data () {
    return {
      isSaving: false,
      savedSuccessfully: false,
      level: null,
      repeatingTheClass: false,
      career: null,
      levels: levels,
      sizes: sizes,
      cellPhoneCompanies: cellPhoneCompanies,
      genders: genders,
      observations: null,
      studentRegistrationStatus: null,
      studyPlan: null,
      studyPlans: [],

      statesOfRegistrationToCareer: statesOfRegistrationToCareer
    }
  },


  computed: {

    registrationToCareer: function () {
      return this.$store.getters.getRegistrationToCareer
    },

    // carreras
    careers: function () {
      return this.$store.getters.getAllCareers
    },

    registrationForm:function(){
      return this.$store.getters.getRegistrationForm
    }

  },


  validations: {
    career: {
      required
    },
    level: {
      required
    },
    registrationForm:{
      personalData: {
        lastName: { required, minLength: minLength(3) },
        firstName:{required, minLength: minLength(3) },
        dni: { required, minLength: minLength(8) },
        gender: { required },
        cuil: { required, minLength: minLength(11) },
        size: { required },
        birthDate:{ required },
        birthPlace:{
          locality: { required },
          province: { required },
          nationality: { required }
        },
        email:{ required, email },
        currentResidence:{
          street: { required },
          streetNumber: { required },
          neighborhood: { required },
          locality: { required },
          province: { required },
          country: { required },
          zipCode: { required},
          phone: { required, minLength: minLength(6) },
          cellPhone: { required, minLength: minLength(8) },
          cellPhoneCompany:{ required }
        }
      }
    },
    studyPlan: {
      required
    }
  },


  methods:{

    getRegistrationToCareer: function () {

      var self = this;
      this.$html.gotoTop();
      this.$loader.loading();

      this.$store.dispatch('getRegistrationToCareer', { registrationToCareer: { _id: this.$route.params.id } })
        .then((response) => {
          if (response.success) {
            self.level = response.data.level;
            self.career = response.data.career._id;
            self.observations = response.data.observations;
            self.repeatingTheClass = response.data.repeatingTheClass;
            self.studentRegistrationStatus = response.data.studentRegistrationStatus;
            if(self.career) {
              self.studyPlans = response.data.career.studyPlans;
            }

            var currentStudyPlanIsListed = self.studyPlans.filter(function (studyPlansItem) {
              return response.data.studyPlan === studyPlansItem._id;
            });
            if(currentStudyPlanIsListed && currentStudyPlanIsListed.length > 0) {
              self.studyPlan = currentStudyPlanIsListed[0]._id;
            } else {
              self.studyPlan = null;
            }

            self.getRegistrationForm(response.data.user._id)
          }
          this.$loader.close();
        })
        .catch((response) => {
          this.$loader.close();
        })

    },


    getRegistrationForm: function (userId) {

      this.$store.dispatch('getRegistrationForm', { user : userId })
        .then((response) => {

          if (!this.registrationForm) {
            this.$store.dispatch('cleanRegistrationForm');
          }

          if(response.data.personalData && response.data.personalData.birthDate) {
            this.registrationForm.personalData.birthDate = response.data.personalData.birthDate.split('T')[0];
          }

        })
        .catch(error => {
          this.$message.error({text: 'Ha ocurrido un error. Intentelo nuevamente mas tarde.'})
        })
    },


    getAllCareers () {
      this.$loader.loading();
      this.$store.dispatch('getAllCareers')
        .then((response) => {
          this.$loader.close();
        })
        .catch((response) => {
          this.$loader.close();
        })
    },


    onCareerHasChanged() {
      var self = this;

      var careerSelected = self.careers.filter(function (item) {
        return self.career === item._id;
      });
      if(careerSelected && careerSelected.length > 0) {
        careerSelected = careerSelected[0];
      }

      self.studyPlans = careerSelected.studyPlans;
      self.studyPlan = null;
    },


    validate () {

      this.$v.registrationForm.personalData.$touch();
      this.$v.career.$touch();
      this.$v.level.$touch();
      this.$v.studyPlan.$touch();

      if( !this.$v.registrationForm.personalData.$error &&
        !this.$v.career.$error &&
        !this.$v.career.$error &&
        !this.$v.studyPlan.$error ) {

        return true

      }

      return false;
    },


    submit () {

      const self = this

      if ( this.validate() ) {

        this.savedSuccessfully = false;
        this.isSaving = true;

        var params = {
          _id: this.$route.params.id,
          studentRegistrationStatus: this.studentRegistrationStatus,
          observations: this.observations,
          career: this.career,
          level: this.level,
          repeatingTheClass: this.repeatingTheClass,
          studyPlan: this.studyPlan
        };

        $('.save-btn').attr('disabled', true)

        this.$store.dispatch('editRegistrationToCareer', {registrationToCareer: params})
          .then((response) => {

            if (response.success) {

              self.editRegistrationForm()

            } else {

              self.$message.error({text: response.message});
              self.isSaving = false;

            }

          })
          .catch((error) => {

            self.isSaving = false;
            self.$message.error({text: 'Ha ocurrido un error. Intentelo nuevamente mas tarde.'});
            $('.save-btn').attr('disabled', false);

          })
      } else {



      }

    },


    verifyPermission: function () {
      var self = this;
      this.statesOfRegistrationToCareer.forEach(function(part, index, item) {
        if(self.$acl.checkPermission('approve-registration-to-careers') && item[index].value == 'pending-step-1') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('approve-registration-to-careers') && item[index].value == 'pending-step-2') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('approve-registration-to-careers') && item[index].value == 'pending-step-3') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('approve-registration-to-careers') && item[index].value == 'conditional-approved') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('approve-registration-to-careers') && item[index].value == 'final-approved') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('approve-registration-to-careers') && item[index].value == 'enrolled-standard') {
          item[index].permit = false;
        }
        if(self.$acl.checkPermission('approve-registration-to-careers') && item[index].value == 'enrolled-for-exams') {
          item[index].permit = false;
        }
        if(self.$acl.checkPermission('approve-registration-to-careers') && item[index].value == 'enrolled-with-a-scholarship') {
          item[index].permit = false;
        }
        if(self.$acl.checkPermission('approve-registration-to-careers') && item[index].value == 'officially-suspended') {
          item[index].permit = false;
        }
        if(self.$acl.checkPermission('approve-registration-to-careers') && item[index].value == 'suspended-ex-officio') {
          item[index].permit = false;
        }

        if(self.$acl.checkPermission('edit-payments') && item[index].value == 'pending-step-1') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('edit-payments') && item[index].value == 'pending-step-2') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('edit-payments') && item[index].value == 'pending-step-3') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('edit-payments') && item[index].value == 'conditional-approved') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('edit-payments') && item[index].value == 'final-approved') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('edit-payments') && item[index].value == 'enrolled-standard') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('edit-payments') && item[index].value == 'enrolled-for-exams') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('edit-payments') && item[index].value == 'enrolled-with-a-scholarship') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('edit-payments') && item[index].value == 'officially-suspended') {
          item[index].permit = true;
        }
        if(self.$acl.checkPermission('edit-payments') && item[index].value == 'suspended-ex-officio') {
          item[index].permit = true;
        }
      });
    },


    editRegistrationForm: function () {

      var self = this;

      if (this.registrationToCareer) {
        this.registrationForm.currentCareer = this.career
      }
      if (this.registrationToCareer) {
        this.registrationForm.currentLevel = this.level
      }
      this.registrationForm.user = this.registrationToCareer.user;

      this.$store.dispatch('editRegistrationForm', { form: this.registrationForm })
        .then((response) => {

          if(response.success) {

            self.$html.gotoTop();

            self.savedSuccessfully = true;
            self.isSaving = false;

            if(response.data.personalData && response.data.personalData.birthDate) {
              self.registrationForm.personalData.birthDate = response.data.personalData.birthDate.split('T')[0];
            }

            self.$message.success();

            setTimeout(function () {
              self.$router.push('/list-registration-to-careers')
            }, 1000)

          } else {

            self.$message.error({text: response.message});
            self.isSaving = false;

          }

          $('.save-btn').attr('disabled', false)

        })
        .catch((error) => {
          self.isSaving = false;
        })
    },


    cancel () {
      this.$router.push('/list-registration-to-careers');
      this.$html.gotoTop();
    }

  }
}
</script>
<style>
  .approvation-buttons .active {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/screens/ApproveRegistrationToCareerScreen.vue